export default {
	path: 'judgementResults',
	name: 'JudgementResultForm',
	component() {
		return import('@/components/judgementResult/JudgementResultForm.vue')
	},
	children: [
		{
			path: '',
			name: 'JudgementResultList',
			component() {
				return import('@/components/judgementResult/JudgementResultList.vue')
			},
		},
	],
}